<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="2">
                <v-btn id="boton-verde" min-width="220"
                @click="esAdmin() ? this.$router.push('/auditoria-reintegros/eleccion-paciente') : this.$router.push('/reintegros/home')"
                block><v-icon icon="mdi mdi-arrow-left"></v-icon></v-btn>
            </v-col>
            <v-col cols="12" md="10">
                <Loader v-if="cargando" class="justify-center align-center" style="z-index: 10000;"></Loader>
            </v-col>
        </v-row>
    </v-container>
    <v-container>
    <v-card class="mb-5" max-width="100%">
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols="12" md="5">
                    <p>Filtrar por fechas:</p>
                    <VueDatePicker 
                        v-model="date"
                        :enableTimePicker="false"
                        :auto-apply="true"
                        range
                        placeholder="Seleccionar rango de fechas"
                        :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
                        :format-locale="es"
                        cancel-text="Cancelar"
                        select-text="Aplicar"
                        @update:model-value="filtradoGeneral"
                        :teleport="true"
                    />
                </v-col>
                <v-col cols="12" md="2">
                    <p>Filtrar por estado/s:</p>
                    <v-select
                        v-model="estados"
                        @update:model-value="filtradoGeneral"
                        clearable
                        chips
                        variant="solo"
                        return-object
                        :items="estadosEnSelect"
                        density="compact"
                        item-title="nombre"
                        multiple
                        hide-details
                    ></v-select>
                </v-col>
                <v-col cols="12" md="5">
                    <p>Buscar por columna:</p>
                    <v-text-field
                        v-model="search"
                        @update:model-value="filtradoGeneral"
                        label="Buscar"
                        prepend-inner-icon="mdi-magnify"
                        variant="solo-filled"
                        density="compact"
                        hide-details
                        single-line
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-divider id="divider" class="mt-4"></v-divider>
        </v-container>
        <v-card-title class="align-center">
            <v-row justify="start" align="start">
                <v-col cols="12" md="4" class="d-flex justify-start">
                    <v-icon class="mr-2">mdi-call-made</v-icon>
                    <h3>Reintegros solicitados</h3>  
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
            :items="listadoEnTabla"
            :headers="esAdmin() ? headersAdmin : headers"
            :items-per-page-options="[5,10,15]"
            :items-per-page-text="'Elementos por pagina:'"
            :no-data-text="'No hay solicitudes realizadas'"
            :no-data-text-style="{'font-size': '2xl'}"
            :loading-text="'Cargando...'"
            :sortBy="[{key: 'fecha', order:'desc'}]"
        >
            <template v-slot:[`item.paciente`]="{ item }">
                <p>{{ item.paciente.apellidoNombre != '-' ? item.paciente.apellidoNombre : ""}}</p>
                <p>{{ item.paciente.numeroAfiliado != '-' ? item.paciente.numeroAfiliado : ""}}</p>
                <p class="font-weight-light">{{ item.paciente.tipoAfiliatorio != '-' ? item.paciente.tipoAfiliatorio : "" }}</p>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
                <v-chip
                    :color="estadosEnSelect.find(e => e.valor == item.estado).color"
                    text-color="white"
                >
                    {{ item.estado }}
                </v-chip>
            </template>

            <template v-slot:[`item.archivos`]="{ item }">
                <ImageModal
                v-if="item.archivos.length > 0"
                :archivos=item.archivos
                @archivo-eliminado="getListado()"
                ></ImageModal>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
                <v-menu
                open-on-hover
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                        id="boton-verde"
                        v-bind="props"
                        :disabled="cargando"
                        :loading="cargando"
                        v-if = "item.estado != 'Aprobado' && item.estado != 'Rechazado'"
                        >
                        <v-icon>mdi mdi-arrow-right</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <div
                        v-for="(estado, i) in estadosEnSelect"
                        :key="i">
                            <v-list-item
                            v-if="estado.valor != item.estado"
                            @click="cambiarEstado(item, estado.valor)"
                            >
                                <v-list-item-title>
                                    {{ estado.nombre }}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </v-card>
    </v-container>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert= false"
    />
</template>

<style src="../assets/general.css"></style>

<script>
/* eslint-disable */
    import '@vuepic/vue-datepicker/dist/main.css';
    import Loader from './Loader.vue';
    import ReintegroService from '@/api/ReintegroService';
    import AlertComponent from './AlertComponent.vue';
    import ImageModal from './ImageModal.vue';
    import { Role } from '@/_helpers/role';

    const reintegroService = new ReintegroService();

    export default {
        components: {
            Loader,
            AlertComponent,
            ImageModal
        },
        data: () => ({
            listadoReintegros: [],
            listadoEnTabla: [],
            date: [],
            search: '',
            estados: [],
            estadosEnSelect:[{nombre:'Pendiente', valor:'Pendiente', color:'primary'}, {nombre:'En proceso de pago', valor:'EnProcesoDePago', color:'orange'}, {nombre:'Aprobado', valor:'Aprobado', color:'green'}, {nombre:'Rechazado', valor:'Rechazado',color:'red'}],
            cargando: false,
            //datos para mostrar errores
            showAlert:false,
            alertTitle: 'Error',
            alertText: 'Credenciales inválidas.',
            alertType: 'error',
            headers: [
                { title: 'Fecha', key: 'fecha'},
                { title: 'Paciente', key: 'paciente'},
                { title: 'CBU', key: 'cbu'},
                { title: 'Numero de reintegro', key: 'numeroDeReintegro'},
                { title: 'Monto declarado', key: 'montoDeclarado'},
                { title: 'CBU', key: 'cbu'},
                { title: 'Tipo reintegro', key: 'opcionElegida'},
                { title: 'Observaciuones', key: 'observaciones'},
                { title: 'Estado', key: 'estado' },
                { title: 'Archivos', key: 'archivos'},
            ],
            headersAdmin:[
                { title: 'Fecha', key: 'fecha'},
                { title: 'Paciente', key: 'paciente'},
                { title: 'CBU', key: 'cbu'},
                { title: 'Numero de reintegro', key: 'numeroDeReintegro'},
                { title: 'Monto declarado', key: 'montoDeclarado'},
                { title: 'CBU', key: 'cbu'},
                { title: 'Tipo reintegro', key: 'opcionElegida'},
                { title: 'Observaciuones', key: 'observaciones'},
                { title: 'Estado', key: 'estado' },
                { title: 'Archivos', key: 'archivos'},
                { title: 'Cambiar estado', key: 'acciones'}
            ]
        }),
        async mounted(){
            this.cargando = true;
            await this.getListado();
            this.cargando = false;
        },
        watch: {
            search(newValue) {
                this.filterListado();
            }
        },
        methods: {
            async getListado(){
                this.listadoReintegros = [];
                this.listadoEnTabla = [];
                const idPaciente = this.$store.getters.getPaciente.id;
                const response = await reintegroService.getReintegrosPaciente(idPaciente);
                if(response && response != undefined && response.status === 200){
                    const listado = response.data;
                    const paciente = this.$store.getters.getPaciente;
                    listado.forEach(element => {
                        this.listadoReintegros.push({
                            paciente: {
                                id: paciente.id,
                                apellidoNombre: paciente.apellidoNombre ? paciente.apellidoNombre : '-',
                                numeroAfiliado: paciente.numeroAfiliado ? paciente.numeroAfiliado : '-',
                                tipoAfiliatorio: paciente.tipoAfiliatorio ? paciente.tipoAfiliatorio : '-',
                                direccion: paciente.direccion ? paciente.direccion : '-',
                                telefono: paciente.telefono ? paciente.telefono : '-',
                                mail: paciente.mail ? paciente.mail : '-',
                                cbu: paciente.cbu ? paciente.cbu : '-',
                            },
                            cbu: element.cbu,
                            numeroDeReintegro: element.numeroDeReintegro,
                            montoDeclarado: element.montoDeclarado,
                            opcionElegida: element.opcionElegida,
                            observaciones: element.observaciones,
                            estado: element.estado,
                            fecha: element.fechaCreacion.split('T')[0],
                            comprobanteCBU: element.comprobanteCBU ? {
                                guid: element.comprobanteCBU.id,
                                nombre: element.comprobanteCBU.nombre,
                                tipoMime: element.comprobanteCBU.tipoMime,
                            } : null,
                            documentacion: element.documentacion.map(documento => ({
                                guid: documento.id,
                                nombre: documento.nombre,
                                tipoMime: documento.tipoMime,
                            })),
                            archivos: [
                                ...(element.comprobanteCBU ? [{
                                    guid: element.comprobanteCBU.id,
                                    nombre: element.comprobanteCBU.nombre,
                                    tipoMime: element.comprobanteCBU.tipoMime
                                }] : []),
                                ...element.documentacion.map(documento => ({
                                    guid: documento.id,
                                    nombre: documento.nombre,
                                    tipoMime: documento.tipoMime
                                }))
                            ],
                            acciones: "Ver documentacion"
                        });
                    });
                    this.listadoEnTabla = this.listadoReintegros.slice();
                }
                else{
                    this.alertTitle= "Error";
                    this.alertText= response.data.mensaje;
                    this.alertType="error";
                    this.showAlert= true;
                }
            },
            filterListado(){
                const searchLower = this.search.toLowerCase();
                return this.listadoReintegros.filter(reintegro => {
                    return (
                        reintegro.paciente.apellidoNombre.toLowerCase().includes(searchLower) ||
                        reintegro.paciente.numeroAfiliado.toLowerCase().includes(searchLower) ||
                        reintegro.paciente.tipoAfiliatorio.toLowerCase().includes(searchLower) ||
                        reintegro.cbu.toLowerCase().includes(searchLower) ||
                        reintegro.numeroDeReintegro.toString().toLowerCase().includes(searchLower) ||
                        reintegro.montoDeclarado.toLowerCase().includes(searchLower) ||
                        reintegro.opcionElegida.toLowerCase().includes(searchLower) ||
                        reintegro.observaciones.toLowerCase().includes(searchLower) ||
                        reintegro.estado.toString().toLowerCase().includes(searchLower)
                    )
                });
            },
            formatDate(date) {
            return date.toISOString().split('T')[0];
            },
            filterPorFecha() {
                const fechaDesde = this.formatDate(this.date[0]);
                const fechaHasta = this.formatDate(this.date[1]);
                return this.listadoReintegros.filter(reintegro => {
                    return this.formatDate(new Date(reintegro.fecha)) >= fechaDesde && this.formatDate(new Date(reintegro.fecha)) <= fechaHasta;
                });
            },
            filterListadoPorEstados(){
                return this.listadoReintegros.filter(reintegro => {
                    return this.estados.some(e => e.valor == reintegro.estado);
                });
            },
            async filtradoGeneral(){
                let listadoFechas = [];
                let listadoSearch = [];
                let listadoEstados = [];
                if(!(this.date != null && this.date[0] != null && this.date[1] != null) && !(this.search.length > 0) && !(this.estados.length > 0)){
                    this.listadoEnTabla = this.listadoReintegros;
                }
                else{
                    if(this.date != null && this.date[0] != null && this.date[1] != null){
                        listadoFechas = await this.filterPorFecha();
                    }
                    if(this.search.length > 0){
                        listadoSearch = this.filterListado();
                    }
                    if(this.estados.length > 0){
                        listadoEstados = this.filterListadoPorEstados();
                    }
                    const allLists = [listadoFechas, listadoSearch, listadoEstados].filter(list => list.length > 0);
                    if (allLists.length > 0) {
                        // Usamos la primera lista como base y hacemos intersección con las otras
                        this.listadoEnTabla = allLists.reduce((acc, list) => 
                            acc.filter(item => list.includes(item))
                        );
                    } else {
                        // this.listadoEnTabla = this.listadoSolicitudes;
                        this.listadoEnTabla = [];
                    }
                }
            },
            async cambiarEstado(reintegro, nuevoEstado){
                this.cargando = true;
                let nuevoReintegro = {...reintegro};
                nuevoReintegro.archivos = [];
                nuevoReintegro.estado = nuevoEstado;
                nuevoReintegro.pacienteId = reintegro.paciente.id;
                const response = await reintegroService.updateReintegro(nuevoReintegro);
                if(response && response != undefined && response.status != 200){
                    this.alertTitle= "Error al actualizar el estado";
                    this.alertText= response.data;
                    this.alertType="error";
                    this.showAlert= true;
                }
                await this.getListado();
                this.cargando = false;
            },
            esAdmin(){
                return this.$store.getters.getRole == Role.AdministrativoReintegros;
            }
        }
    }
</script>